// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Cm-z","tupacHeader":"Dm-z","tupacHeader2":"Em-z","tupacMenu":"Fm-z","tupacMenu2":"Gm-z","tupacMain":"Hm-z","tupacMain2":"Im-z"};